module.exports = __webpack_public_path__ + "static/media/uga.9d0188ba.svg";